<template>
  <div class="choose-course">
    <Modal v-model="show" title="选择课程商品" :footer-hide="true" width="80">
      <div class="flex">
        <div class="left">
          <div class="search-line">
            <Input
              v-model="courseSearchData.keyWord"
              class="search-input"
              placeholder="资源名称"
              clearable
            ></Input>
            <Select
              v-model="courseSearchData.termId"
              clearable
              style="width: 200px; margin-right: 8px"
              disabled
            >
              <Option
                v-for="item in termList"
                :key="item.termId"
                :value="item.termId"
              >{{ item.yearName }}{{ item.termName }}</Option>
            </Select>

            <choose-apply
              ref="chooseApplyRef"
              :placeholder="`资源提供方`"
              class="search-input"
              @on-change="handleOnApplyChange"
            ></choose-apply>
            <Select
              v-model="courseSearchData.classType"
              class="search-input"
              placeholder="资源类别"
            >
              <Option
                v-for="item in courseTypeList"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</Option>
            </Select>
            <Select
              v-model="courseSearchData.classroomState"
              style="width: 100px; margin-right: 16px"
              placeholder="上架状态"
            >
              <Option value="4">已上架</Option>
            </Select>
            <Select
              v-model="courseSearchData.visibleType"
              style="width: 100px; margin-right: 16px"
              placeholder="列表可见"
              clearable
            >
              <Option value="1">可见</Option>
              <Option value="0">不可见</Option>
            </Select>
            <Button
              type="primary"
              style="margin-right: 8px"
              @click="handleGetSearchValue"
            >搜索</Button>
            <Button class="reset-btn" @click="handleResetSearch">重置</Button>
          </div>
          <div class="table">
            <Table
              ref="selection"
              border
              :max-height="450"
              :columns="courseListColumn"
              :data="courseGoodsList"
              :loading="tableLoading"
              @on-select="onSelect"
              @on-select-cancel="onSelectCancel"
              @on-select-all="onSelectAll"
              @on-select-all-cancel="onSelectAllCancel"
              @on-selection-change="onSelectionChange"
            >
              <template slot="timeDesc" slot-scope="{ row }">
                <TablePoptip :content="row.timeDesc" :show-poptips-content-length="30" :content-width="230"> </TablePoptip>
              </template>
              <template slot="classroomState" slot-scope="{ row }">
                <span>已上架</span>
              </template>
              <template slot="visibleType" slot-scope="{ row }">
                <span>{{ row.visibleType == 1 ? '可见' : '不可见' }}</span>
              </template>
            </Table>
            <div class="page-main">
              <Page
                :total="coursePageInfo.total"
                show-total
                :current="coursePageInfo.pageNum"
                class="page-right"
                @on-change="handlePageChange"
              ></Page>
            </div>
            <div class="iconTips">
              <p>① 针对限定报名范围的课程，个人圈定的课程不支持组合成套餐。</p>
              <p>②已下架的课程商品，不支持组合至套餐。相同的才可组合成套餐。</p>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="head">选中({{ selectCourseList.length }})</div>
          <div class="right-table">
            <Table
              :columns="rightColumns"
              border
              :data="selectCourseList"
              height="550"
            >
              <template slot="sort" slot-scope="{ row, index }">
                <InputNumber
                  v-model="selectCourseList[index]['sort']"
                  :min="1"
                  style="width: 70px"
                ></InputNumber>
              </template>
              <template slot="action" slot-scope="{ row, index }">
                <Button
                  type="error"
                  size="small"
                  @click="handleRemove(row, index)"
                >删除</Button>
              </template>
            </Table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <Button
          style="margin-right: 16px"
          @click="handleCancleBtn"
        >取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
    <!-- <ChooseAndModal
      ref="chooseCourse"
      modal-title="选择课程商品"
      :table-column="courseListColumn"
      :table-data="courseGoodsList"
      :table-total="coursePageInfo.total"
      :table-current="coursePageInfo.pageNum"
      :selectType="2"
      @emitSelectData="getSelectCourseRow"
      @pageChange="handlePageChange"
    >
    </ChooseAndModal> -->
  </div>
</template>

<script>
import ChooseAndModal from '@c/ChooseAndModal.vue';
import courseCenter from '@/request/courseCenter/index.js';
import resources from '@/request/courseCenter/resources.js';

import { gradeStrList, courseLevelStrList } from '@/utils/dictionary.js';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
import ChooseApply from '@c/searchBlock/ChooseApply.vue';

export default {
  components: {
    ChooseAndModal,
    ChooseApply
  },
  props: {
    schoolId: {
      type: String,
      default: ''
    },
    termId: {
      type: String,
      default: ''
    }
    // searchCourseType: {
    //   type: Number,
    //   default: 0
    // }
  },

  data() {
    return {
      show: false,
      courseSearchData: {
        keyWord: '',
        providerId: '',
        classType: 1,
        termId: '',
        classroomState: '4',
        visibleType: ''
      },
      selectCourseList: [], // 选中的课程
      rightColumns: [

        {
          title: '商品名称',
          key: 'productName',
          minWidth: 100
        },
        {

          title: '排序',
          slot: 'sort',
          width: 100,
          align: 'center',
          renderHeader: (h, params) => {
            return h(
              'Tooltip',
              { props: { placement: 'top', transfer: true, 'max-width': '300' }}, // 提示组件的属性
              [
                h('span', [
                  h('span', '排序'), // 列名
                  h('Icon', { props: { type: 'ios-alert-outline' }}) // 问号图标
                ]),
                h(
                  'span',
                  {
                    slot: 'content'
                  },
                  '数值越小，排序越靠前！'
                ) // 提示内容
              ]
            );
          }
        },
        {
          title: '操作',
          slot: 'action',
          width: 150,
          align: 'center'
        }
      ], //
      trainingType: '',
      yearTerms: '',
      termList: [],
      loadingApply: false,
      applyList: [],
      courseType: {
        // 11: '艺术',
        // 12: '科技',
        // 13: '体育',
        // 14: '美术',
        // 15: '综合实践',
        // 21: '早托',
        // 22: '午托',
        // 23: '晚托',
        // 24: '全托'
        1: '素质课',
        2: '基础托管'
      },
      courseTypeList: [
        {
          name: '素质课',
          id: 1
        },
        {
          name: '基础托管',
          id: 2
        }
      ], // 课程类别
      courseListColumn: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '商品名称',
          key: 'productName',
          fixed: 'left',
          minWidth: 230
        },
        {
          title: '课时',
          key: 'classroomTotal',
          width: 80,
          fixed: 'left'
        },
        {
          title: '价格（元）',
          key: 'classroomFee',
          width: 120,
          fixed: 'left',
          render: (h, params) => {
            return h('div', [
              params.row.classroomFee
                ? Number(params.row.classroomFee) / 100
                : ''
            ]);
          }
        },
        {
          title: '预计上课',
          slot: 'timeDesc',
          minWidth: 238
        },
        {
          title: '课程名称',
          key: 'courseName',
          minWidth: 238
        },
        {
          title: '课程资源学期',
          key: 'termName',
          width: 200
        },

        // {
        //   title: '资源级别',
        //   key: 'courseLevel',
        //   width: 238,
        //   render: (h, params) => {
        //     return h('div', [params.row.courseLevel ? courseLevelStrList[params.row.courseLevel] : '-']);
        //   }
        // },
        // {
        //   title: '推荐年级',
        //   key: 'gradeMin',
        //   width: 238,
        //   render: (h, params) => {
        //     return h('div', [`${params.row.gradeMin ? gradeStrList[params.row.gradeMin] : ''}至${params.row.gradeMax ? gradeStrList[params.row.gradeMax] : ''}`]);
        //   }
        // },
        {
          title: '资源提供方',
          key: 'providerName',
          minWidth: 250
        },
        {
          title: '课程类别',
          key: 'classType',
          width: 120,
          render: (h, params) => {
            return h('div', [
              params.row.classType
                ? this.courseType[params.row.classType]
                : ''
            ]);
          }
        },
        {
          title: '报名范围',
          key: 'isLimitEnrollStr',
          width: 130
        },
        {
          title: '是否可见',
          slot: 'visibleType',
          width: 130
        },
        {
          title: '上架状态',
          slot: 'classroomState',
          width: 130
        }

      ], // 课程商品表格column
      courseGoodsList: [], // 课程商品列表
      coursePageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      },
      portOrg: Number(localStorage.getItem('portOrg')),
      tableLoading: false
    };
  },
  watch: {
    termId(val) {
      this.courseSearchData.termId = val;
    }
    // searchCourseType(newVal) {
    //   this.courseSearchData.classType = newVal
    // }
  },

  created() { },
  mounted() { },
  methods: {
    init() {
      this.coursePageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.courseGoodsList = [];
      //  this.getApplyList()
      this.getYearTerm();

      //  this.getyearTermsListFun()
      this.getCourseList();
    },
    open(productList) {
      this.show = true;
      this.selectCourseList = productList;
      this.init();
    },
    handleCancleBtn() {
      this.show = false;
    },
    // 提交
    handleSureBtn() {
      // if (this.selectCourseList.length < 2) {
      //   this.$Message.error('至少选择2门课程商品');
      //   return null;
      // }
      const noKey = this.selectCourseList.findIndex(item => { return item.sort == null; });
      if (noKey != -1) {
        this.$Message.error('排序序号不可为空！');
        return null;
      }
      const sortArr = this.selectCourseList.map(item => { return item.sort; });
      if (sortArr.length != [...new Set(sortArr)].length) {
        const map = new Map();
        const dups = sortArr.reduce((acc, curr) => {
          if (map.has(curr) && acc.indexOf(curr) == -1) {
            acc.push(curr);
          } else {
            map.set(curr, curr);
          }
          return acc;
        }, []);
        if (dups.length > 0) {
          this.$Message.error(`${dups[0]}序号已存在，序号不可重复`);
          return null;
        }
      }
      this.show = false;
      this.$emit('on-finish', this.selectCourseList);
    },

    getSelectCourseRow(row) {
      console.log(row);
    },
    handlePageChange(page) {
      this.coursePageInfo.pageNum = page;
      this.getCourseList();
    },
    handleOnApplyChange(val) {
      this.courseSearchData.providerId = val.orgId;
    },
    // 请求提供方列表
    // async getApplyList(name) {
    //   const params = {
    //     pageNum: 1,
    //     pageSize: 100,
    //     orgName: name
    //   };

    //   this.loadingApply = true;
    //   const res = await courseCenter.getListCourseOrder(params);
    //   if (res.status === 200) {
    //     this.applyList = res.message.list.map(item => {
    //       item.id = item.orgId;
    //       return item;
    //     });
    //     this.loadingApply = false;
    //   }
    // },
    // 获取商品课程列表
    async getCourseList() {
      const params = {
        schoolId: this.schoolId,
        pageNum: this.coursePageInfo.pageNum,
        pageSize: this.coursePageInfo.pageSize
      };
      const paramsTrue = Object.assign(params, this.courseSearchData);
      if (this.yearTerms.length === 2) {
        paramsTrue.yearCode = this.yearTerms[0];
        paramsTrue.termCode = this.yearTerms[1];
      }
      let res;
      //
      this.tableLoading = true;
      if (this.portOrg == 2) {
        res = await courseCenter.getSubProductPageBySch(paramsTrue);
      } else {
        res = await courseCenter.getSubProductPage(paramsTrue);
      }
      this.tableLoading = false;
      if (res.status === 200) {
        this.courseGoodsList = res.message.list.map(item => {
          // item.classTimeShow = dealTimeList(item);
          item.id = item.productId;

          return item;
        });
        this.coursePageInfo.total = Number(res.message.total);
        this.handleCourseGoodsList();
      }
    },
    handleGetSearchValue() {
      this.coursePageInfo.pageNum = 1;
      this.coursePageInfo.total = 0;
      this.getCourseList();
    },
    handleResetSearch() {
      this.$refs.chooseApplyRef && this.$refs.chooseApplyRef.handleClear();
      this.courseSearchData = {
        keyWord: '',
        providerId: '',
        classType: this.courseSearchData.classType,
        termId: '',
        classroomState: '4',
        visibleType: ''
      };
    },
    onSelectionChange(selection, row) { },
    onSelectCancel(selection, row) {
      const key = this.selectCourseList.findIndex(item => {
        return item.productId == row.productId;
      });
      if (key != -1) {
        this.selectCourseList.splice(key, 1);
      }
    },
    onSelectAll(selection) {
      selection.forEach(item => {
        this.onSelect(selection, item, true);
      });

      if (this.selectCourseList.length > 1) {
        const isLimitEnrollStr = this.selectCourseList[0]['isLimitEnrollStr'];
        const unArr = this.selectCourseList.filter(item => { return item.isLimitEnrollStr != isLimitEnrollStr; });
        console.log(unArr);

        if (unArr.length > 0) {
          this.$Modal.confirm({
            title: '温馨提示',
            content: '所选课程商品非相同的报名范围，是否继续组合成套餐？组合成套餐后，报名范围受套餐的报名范围限制',
            onOk: () => {

            },
            onCancel: () => {
              unArr.forEach(item => {
                const key = this.selectCourseList.findIndex(subItem => { return subItem.productId == item.productId; });
                this.selectCourseList.splice(key, 1);
              });

              this.handleCourseGoodsList();
            }
          });
        }
      }
    },
    onSelectAllCancel(selection) {
      this.courseGoodsList.forEach(item => {
        this.onSelectCancel(selection, item);
      });
    },
    onSelect(selection, row, type) {
      const key = this.selectCourseList.findIndex(item => {
        return item.productId == row.productId;
      });
      if (key == -1) {
        const obj = {
          ...row,
          sort: this.selectCourseList.length > 0 ? this.selectCourseList[this.selectCourseList.length - 1]['sort'] + 1 : 1
        };
        this.selectCourseList.push(obj);
      }
      if (this.selectCourseList.length > 1 && !type) {
        const isLimitEnrollStr = this.selectCourseList[0]['isLimitEnrollStr'];
        if (row.isLimitEnrollStr != isLimitEnrollStr) {
          this.$Modal.confirm({
            title: '温馨提示',
            content: '所选课程商品非相同的报名范围，是否继续组合成套餐？组合成套餐后，报名范围受套餐的报名范围限制',
            onOk: () => {

            },
            onCancel: () => {
              this.selectCourseList.splice(this.selectCourseList.length - 1, 1);
              this.handleCourseGoodsList();
            }
          });
        }
      }
    },
    // 删除
    handleRemove(row, index) {
      this.selectCourseList.splice(index, 1);
      this.handleCourseGoodsList();
    },
    unSelectTable(ids) {
      this.courseGoodsList.forEach(item => {
        item._checked = false;
        // const key = ids.findIndex(item_1 => {
        //   return item_1 == item.productId;
        // });
        if (!(ids.includes(item.productId))) {
          item._checked = true;
        }
      });
      this.courseGoodsList = Object.assign([], this.courseGoodsList);
    },
    // 处理列表选中效果
    handleCourseGoodsList() {
      this.courseGoodsList.forEach(item => {
        item._checked = false;
        const key = this.selectCourseList.findIndex(item_1 => {
          return item_1.productId == item.productId;
        });
        if (key != -1) {
          item._checked = true;
        }
      });
      this.courseGoodsList = Object.assign([], this.courseGoodsList);
    },
    async getYearTerm(orgId) {
      const res = await courseCenter.getListTerms({
        orgId: this.schoolId,
        termState: 1
      });
      if (res.status == 200) {
        this.termList = res.message;
      }
    },
    // 搜索框 学期列表
    async getyearTermsListFun(newval) {
      // 学校
      const res = await courseCenter.getDataSearchYearList();
      try {
        if (res.status === 200) {
          const dictValue = JSON.parse(res.message.dictValue);
          const termList = [];
          dictValue.forEach(item => {
            // console.log(item);
            termList.push({
              value: item.sort,
              label: item.value,
              children: [
                {
                  value: '1',
                  label: '第一学期'
                },
                {
                  value: '2',
                  label: '第二学期'
                }
              ]
            });
          });
          this.termList = termList;
        }
      } catch (err) { }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
  .search-select {
    width: 250px;
    margin-right: 16px;
  }
}
.iconTips {
  /* display: flex;
  align-items: center; */
  padding-left: 20px;
  margin: 0 0 10px 10px;
  width: 600px;
  /* height: 30px; */
  background-color: #fffae2;
  border: solid 1px #ffe184;
}
.page-main {
  text-align: right;
  padding: 16px 0;
}
.flex {
  display: flex;
  .left {
    width: 70%;
    margin-right: 20px;
  }
  .right {
    width: 28%;
    .head {
      background: rgba(0, 0, 0, 0.05);
      padding: 8px;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }
}
.modal-footer {
  text-align: right;
  padding: 10px 0;
}
</style>
